export function initHotjar(hotjarId, hotjarVersion, hotjarDebug = false, logCallback) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (window.hj && document.getElementById('hotjar-script')) return true;

  window.hj = window.hj || function hotjarQueue() {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
  window._hjSettings = {
    hjid: hotjarId,
    hjsv: hotjarVersion,
    hjdebug: Boolean(hotjarDebug),
  };

  const script = document.createElement('script');
  script.id = 'hotjar-script';
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${hotjarId}.js?sv=${hotjarVersion}`;
  document.head.appendChild(script);
  if (typeof logCallback === 'function') logCallback('Hotjar ready: true');
  return true;
}
